import { render, staticRenderFns } from "./BlockKeywords.vue?vue&type=template&id=6179f05a"
import script from "./BlockKeywords.vue?vue&type=script&lang=js"
export * from "./BlockKeywords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports